import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/godzilla.png'


const _withScopeId = n => (_pushScopeId("data-v-305bf347"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "additional-service-card",
  small: ""
}
const _hoisted_2 = {
  key: 0,
  class: "additional-service-card__image",
  src: _imports_0
}
const _hoisted_3 = { class: "additional-service-card__name" }
const _hoisted_4 = { class: "additional-service-card__footer" }
const _hoisted_5 = { class: "additional-service-card__price" }
const _hoisted_6 = { class: "additional-service-card__price-value" }
const _hoisted_7 = { class: "additional-service-card__price-unit" }
const _hoisted_8 = {
  key: 0,
  class: "additional-service-card__quantity"
}
const _hoisted_9 = { class: "additional-service-card__label" }

import { PropType } from 'vue'
import BaseNumberIncrementer from '@/components/BaseNumberIncrementer.vue'
import { AdditionalServiceInformation } from '@/models/public/service.model'
import { formatCurrency } from '@/utils/formatters'
import PhotoGallery from '@/components/public/PhotoGallery.vue'
import { useAdditionalServiceMediaFileQuery } from '@/queries/public/services'
import { getServiceUnitLabel } from '@/enums/services'
import BaseIcon from '@/components/BaseIcon.vue'
import { TRANSLATION_TYPE } from '@/enums/public'

export interface AdditionalServiceInformationWithQuantity
  extends AdditionalServiceInformation {
  quantity: number // Integer
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalServiceCard',
  props: {
  modelValue: {
    type: Object as PropType<AdditionalServiceInformationWithQuantity>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props) {

const props = __props


const {
  isLoading: isMediaFileLoading,
  isError: isMediaFileError,
  data: serviceMediaFile,
} = useAdditionalServiceMediaFileQuery(props.modelValue.id, false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    (
        !_unref(isMediaFileLoading) && !_unref(isMediaFileError) && _unref(serviceMediaFile)?.length
      )
      ? (_openBlock(), _createBlock(PhotoGallery, {
          key: 1,
          photos: _unref(serviceMediaFile),
          "show-header-only": true,
          class: "additional-service-card__gallery"
        }, null, 8, ["photos"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, _toDisplayString(__props.modelValue.name?.content), 1),
      (__props.modelValue.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
        ? (_openBlock(), _createBlock(BaseIcon, {
            key: 0,
            icon: "google-translate",
            style: {"height":"16px","min-height":"16px","width":"revert","display":"block"}
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(formatCurrency)(__props.modelValue.price)), 1),
        _createElementVNode("span", _hoisted_7, _toDisplayString('/' + _unref(getServiceUnitLabel)(__props.modelValue.unit)), 1)
      ]),
      (__props.disabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('amount')) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(__props.modelValue.quantity), 1)
          ]))
        : (_openBlock(), _createBlock(BaseNumberIncrementer, {
            key: 1,
            amount: __props.modelValue.quantity,
            "min-amount": 0,
            disabled: __props.disabled,
            onClickMinus: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$emit('update:modelValue', {
            ...__props.modelValue,
            quantity: Math.max(0, __props.modelValue.quantity - 1),
          })
        )),
            onClickPlus: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.$emit('update:modelValue', {
            ...__props.modelValue,
            quantity: __props.modelValue.quantity + 1,
          })
        ))
          }, null, 8, ["amount", "disabled"]))
    ])
  ]))
}
}

})